import { get } from 'lodash-es';

export const selectType = (state, importType) => {
  return get(state, importType, {});
};
